module.exports = __webpack_public_path__ + "img/social_responsibility_cheque.57ea2fee.jpg";